<template>
  <!-- eslint-disable unimport/auto-insert-->
  <!-- Disabling unimport/auto-insert here due misdetection of min keyword -->
  <div>
    <!--
      `silent` switches off error messages
      Setting min/max at the same time as setting range causes errors.
      This error causes no issues.
      Source: https://github.com/NightCatSama/vue-slider-component/issues/343#issuecomment-482508771-->
    <ClientOnly>
      <VueSlider
        :dot-attrs="{ tabindex: -1 }"
        :enable-cross="false"
        :interval="1"
        :max="max"
        :min="min"
        :model-value="range"
        adsorb
        contained
        drag-on-click
        height="2px"
        silent
        tooltip="always"
        tooltip-placement="top"
        @dragging="emit('dragging')"
        @error="emit('error')"
        @update:model-value="updateRange"
        @drag-start="emit('dragStart', range)"
        @drag-end="emit('dragEnd', range)"
      >
        <template #dot>
          <button
            class="flex size-4 cursor-pointer rounded-full bg-primary focus:outline-none"
            tabindex="-1"
          >
            <span class="m-auto size-3 rounded-full bg-white" />
          </button>
        </template>
        <template #tooltip="{ value }">
          <div class="rounded bg-gray-200 p-1 text-sm text-gray-600">
            {{ value }}%
          </div>
        </template>
      </VueSlider>
    </ClientOnly>
    <div class="mt-4 flex items-center">
      <SFReductionInput
        :max="range[1]"
        :min="min"
        :model-value="range[0]"
        @update:model-value="changeRangeAtIndex($event, 0)"
      />
      <div class="mx-auto text-center text-xs font-semibold text-secondary">
        {{ $t('price_range_slider.to') }}
      </div>
      <SFReductionInput
        :max="max"
        :min="range[0]"
        :model-value="range[1]"
        @update:model-value="changeRangeAtIndex($event, 1)"
      />
    </div>
  </div>
  <!-- eslint-enable unimport/auto-insert-->
</template>

<script lang="ts" setup>
// By default, the vue-slider-component does not support SSR.
// We can work around this by importing js and styles separately
// https://nightcatsama.github.io/vue-slider-component/#/?hash=server-side-rendering-ssr
// @ts-expect-error Could not find a declaration file for module 'vue-slider-component/dist-css/vue-slider-component.umd.min.js'. '(...)' implicitly has an 'any' type.
import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min.js'
import 'vue-slider-component/dist-css/vue-slider-component.css'
import '@/assets/css/slider/default.css'
import type { RangeTuple } from '@scayle/storefront-product-listing'

import { ClientOnly } from '#components'
import SFReductionInput from '#storefront-ui/components/form/SFReductionInput.vue'

const { min = 0, max = 100 } = defineProps<{
  min?: number
  max?: number
}>()

const range = defineModel<RangeTuple>({
  required: true,
  set([min, max]) {
    return [min, max]
  },
  get([min, max]) {
    return [min, max]
  },
})

const emit = defineEmits<{
  dragging: []
  error: []
  dragEnd: [range: RangeTuple]
  dragStart: [range: RangeTuple]
  inputFieldUpdate: [range: RangeTuple]
}>()

const changeRangeAtIndex = (newRangeValue: number, index: 0 | 1) => {
  console.log(newRangeValue, index)
  const updatedRange = [...range.value]
  updatedRange[index] = newRangeValue
  range.value = updatedRange as RangeTuple

  emit('inputFieldUpdate', range.value)
}

const updateRange = (newRange: RangeTuple) => {
  range.value = newRange
}
</script>
